import React from 'react';

interface CalibTextFieldProps {
    label?: string;
    value?: string | number;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    preview?: boolean; // For a non-editable preview mode
    disabled?: boolean; // To disable the input
    addStyle?: string; // Additional Tailwind CSS styles
}

const CalibTextField: React.FC<CalibTextFieldProps> = ({ label, value, onChange, preview, disabled, addStyle = "" }) => {
    if (preview) {
        return (
            <div className={`font-inter text-base font-medium leading-6 tracking-tight text-left ${addStyle}`}>
                {value}
            </div>
        );
    }

    return (
        <div className={`relative w-[200px] h-[48px] ${addStyle}`}>
            <input 
                type="text"
                value={value}
                onChange={onChange}
                disabled={disabled}
                className="w-full h-full px-3 py-2 border rounded-[2px] border-gray-300 bg-white text-[14px] !font-inter !font-medium leading-6 tracking-tight placeholder-gray-500 focus:border-blue-500 focus:outline-none"
                placeholder={label}
            />
        </div>
    );
}

export default CalibTextField;
